// src/components/Navbar.jsx
import React, { useState, useEffect, useRef } from 'react';
import '../styles/Navbar.css';
import logo from '../Assets/Images/Akij-Insaf-logo.png';
import { FaChevronDown, FaChevronUp, FaEnvelope, FaBars, FaTimes, FaPhoneAlt } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';

function Navbar() {
  const [openMenu, setOpenMenu] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('');

  const menuItems = [
    {
      title: 'About Akij INSAF',
      anchor: '#about',  // scrolls to about section
    },
    {
      title: 'Our Businesses',
      submenu: [
        { label: 'Akij Textile Mills Ltd.', path: '/akij-textile-mills' },
        { label: 'Akij Bakers Ltd', path: '/akij-bakers' },
        { label: 'Akij Flour Mills Ltd', path: '/akij-flour-mills' },
        { label: 'Akij Printing & Packages Ltd', path: '/akij-printing' },
        { label: 'Lighthouse International School', path: '/Lighthouse-International' },
        { label: 'Akij Foundation School, Manikgonj', path: '/Akij-Foundation' },
        { label: 'Akij Foundation Madrasa', path: '/Akij-Foundation' },
        { label: 'Al-Madrasatul Munowwaroh', path: '/Akij-Foundation' },
        { label: 'Monowara Active Technical Institute', path: '/Monowara-Active-Technical' },
        { label: 'Monowara Hospital & Diagonostic Center', path: '/Monowara-Active-Technical' },
        { label: 'WAAW Fashion', path: '/Lighthouse-International' },
      ],
    },
    {
      title: 'Contact Us',
      path: '/contact',
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const aboutSection = document.getElementById('about');
      if (aboutSection) {
        const rect = aboutSection.getBoundingClientRect();
        const offset = window.innerHeight / 2;

        if (rect.top <= offset && rect.bottom >= offset) {
          setActiveSection('about');
        } else {
          setActiveSection('');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="main-header-home">
      <div className="nav-container-home">
        <Link to="/" className="logo-link-home" onClick={() => setIsMobileMenuOpen(false)}>
          <img src={logo} alt="Akij Insaf Group" className="main-logo-home" />
        </Link>

        <button
          className="hamburger-button"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <nav className={`nav-menu-home ${isMobileMenuOpen ? 'open' : ''}`}>
          <ul>
            {menuItems.map((item, index) => {
              const isActive = item.anchor === '#about' && activeSection === 'about';
              return (
                <li
                  key={index}
                  className={`dropdown-home ${isActive ? 'active-menu' : ''}`}
                  onMouseEnter={() => setOpenMenu(index)}
                  onMouseLeave={() => setOpenMenu(null)}
                >
                  {item.path || item.anchor ? (
                    item.path ? (
                      <Link
                        to={item.path}
                        className="menu-link-home"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        {item.title}
                      </Link>
                    ) : (
                      <a
                        href={item.anchor}
                        className={`menu-link-home ${isActive ? 'active' : ''}`}
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        {item.title}
                      </a>
                    )
                  ) : (
                    <>
                      <a href="#" className="menu-link-home">
                        {item.title}{' '}
                        {openMenu === index ? (
                          <FaChevronUp className="dropdown-icon-home" />
                        ) : (
                          <FaChevronDown className="dropdown-icon-home" />
                        )}
                        </a> 
                        
                      {openMenu === index && (
                        <ul className="dropdown-menu-home">
                          {item.submenu.map((subItem, subIndex) => (
                            <li key={subIndex}>
                              <Link to={subItem.path} onClick={() => setIsMobileMenuOpen(false)}>
                                {subItem.label}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>

        <div className="header-right-section-home">
          <div className="email-block-home">
            <div className="email-label-home">
              <FaPhoneAlt className="email-icon-home" /> Call us at
            </div>
            <a className="email-link-home">Our hotline: 01730353735</a>
          </div>
          <div className="email-block-home">
            <div className="email-label-home">
              <FaEnvelope className="email-icon-home" /> Email us at
            </div>
            <a href="mailto:info@akijinsaf.com" className="email-link-home">
              info@akijinsaf.com
            </a>
          </div>
          <div className="quote-block-home">
            <div className="quote-frame-home">
              <span className="quote-text-home">" Quality First "</span>
              <div className="quote-author-home">–SK. AKIJ UDDIN</div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
